import Swiper, {Pagination, Navigation} from "swiper";
import {MD_WIDTH, LG_WIDTH, XL_WIDTH} from "@main/helpers/const";

class ProgramsSlider {
    constructor(el) {
        this.el = el;
        this.swiperNode = this.el.querySelector(".swiper");
        this.prev = this.el.querySelector(".js-programs-slider-prev");
        this.next = this.el.querySelector(".js-programs-slider-next");
        this.pagination = this.el.querySelector(".js-programs-slider-pagination");
        if (this.el.dataset.always) {
            this.createSlider();
        } else {
            this.resizeObserver = new ResizeObserver(this.onResizeWindow.bind(this), 200);
            this.resizeObserver.observe(document.body);
        }
    }

    onResizeWindow([entry]) {
        if (entry.contentRect.width >= LG_WIDTH && this.swiper) {
            this.swiper.destroy(true, true);
            delete this.swiper;
        } else if (entry.contentRect.width < LG_WIDTH && !this.swiper) {
            this.createSlider();
        }
    }

    createSlider() {
        let slidesPerView = 2;
        let options = {
            slidesPerView: "auto",
            modules: [],
            spaceBetween: 18,
            loopFillGroupWithBlank: false,
            centeredSlidesBounds: true,
            breakpoints: {
                [MD_WIDTH]: {
                    spaceBetween: 20,
                    slidesPerView: this.el.dataset.slidesMd || "auto",
                },
                [LG_WIDTH]: {
                    slidesPerView: this.el.dataset.slidesLg || slidesPerView,
                    spaceBetween: 17
                },
                [XL_WIDTH]: {
                    slidesPerView: this.el.dataset.slidesXl || slidesPerView,
                    spaceBetween: 22
                }
            }
        };
        if (this.prev && this.next) {
            options.modules.push(Navigation);
            options.navigation = {
                nextEl: this.next,
                prevEl: this.prev
            };
        }
        if (this.pagination) {
            options.modules.push(Pagination);
            options.pagination = {
                el: this.pagination,
                bulletElement: "button",
                clickable: true
            };
        }
        this.swiper = new Swiper(this.swiperNode, options);
    }
}

window.addEventListener("load", function() {
    document
        .querySelectorAll(".js-programs-slider")
        .forEach(slider => new ProgramsSlider(slider));
});
